import { render, staticRenderFns } from "./shopee.vue?vue&type=template&id=fcf0d05a&scoped=true&"
import script from "./shopee.vue?vue&type=script&lang=js&"
export * from "./shopee.vue?vue&type=script&lang=js&"
import style0 from "./shopee.vue?vue&type=style&index=0&id=fcf0d05a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf0d05a",
  null
  
)

export default component.exports